/* Adorned by Lior - cart drawer: the "New customers save 10% with code ADORN" line is a button (2026-10-10, owner).
   One tap applies the code through the cart's own discount form, so it is the same request, the same error
   messages and the same refresh as typing the code and pressing APPLY. The line itself is a Custom Liquid block
   in the theme settings (<div class="lior-cart-promo"><p>... <span>CODE</span></p></div>): the code is read
   from its <span>, so changing the code in the theme editor needs no change here.
   Once the code is on the cart the line reads "Discount applied" (the wording the owner asked for) and is no longer a button.
   Styles: assets/lior-cart-clean.css. Loaded from sections/cart-drawer.liquid. */
(function () {
  if (window.__liorCartPromo) return;
  window.__liorCartPromo = true;

  var TICK = '<svg aria-hidden="true" focusable="false" viewBox="0 0 12 12"><path d="M2 6.4 4.7 9 10 3.3"/></svg>';

  function drawer() {
    return document.querySelector('cart-drawer');
  }
  function promoOf(d) {
    return d ? d.querySelector('.cart-drawer__body .lior-cart-promo') : null;
  }
  function codeOf(promo) {
    var saved = promo.getAttribute('data-lior-code');
    if (saved) return saved;
    var span = promo.querySelector('p span');
    var code = span ? span.textContent.replace(/\s+/g, '').toUpperCase() : '';
    if (code) promo.setAttribute('data-lior-code', code);
    return code;
  }
  function appliedCodes(d) {
    var block = d.querySelector('cart-discount-block');
    var raw = block ? block.getAttribute('data-applied-codes') || '' : '';
    return raw.split(',').map(function (c) { return c.replace(/\s+/g, '').toUpperCase(); }).filter(Boolean);
  }
  function formOf(d) {
    var form = d.querySelector('cart-discount-block form.cart-discount-form');
    var input = form ? form.querySelector('input[name="cart-discount-field"]') : null;
    return form && input ? { form: form, input: input } : null;
  }

  /* Puts the line into the state the cart is in. Safe to call any number of times: it only touches the DOM
     when the state really changes, so the observer below cannot loop. */
  function sync() {
    var d = drawer();
    var promo = promoOf(d);
    if (!promo) return;
    var code = codeOf(promo);
    if (!code) return;
    var state = appliedCodes(d).indexOf(code) > -1 ? 'applied' : (formOf(d) ? 'ready' : 'plain');
    if (promo.getAttribute('data-lior-state') === state) return;
    promo.setAttribute('data-lior-state', state);
    promo.classList.remove('lior-cart-promo--busy');
    var p = promo.querySelector('p');
    if (state === 'applied') {
      if (p && !promo.__liorOriginal) promo.__liorOriginal = p.innerHTML;
      if (p) p.innerHTML = TICK + 'Discount applied';
      promo.removeAttribute('role');
      promo.removeAttribute('tabindex');
      promo.removeAttribute('aria-label');
    } else {
      if (p && promo.__liorOriginal) p.innerHTML = promo.__liorOriginal;
      if (state === 'ready') {
        promo.setAttribute('role', 'button');
        promo.setAttribute('tabindex', '0');
        promo.setAttribute('aria-label', (p ? p.textContent.replace(/\s+/g, ' ').trim() : code) + '. Apply code ' + code);
      } else {
        promo.removeAttribute('role');
        promo.removeAttribute('tabindex');
        promo.removeAttribute('aria-label');
      }
    }
  }

  function apply(promo) {
    var d = drawer();
    var f = d ? formOf(d) : null;
    var code = codeOf(promo);
    if (!f || !code || promo.getAttribute('data-lior-state') !== 'ready') return;
    if (promo.classList.contains('lior-cart-promo--busy')) return;
    promo.classList.add('lior-cart-promo--busy');
    f.input.value = code;
    if (typeof f.form.requestSubmit === 'function') {
      f.form.requestSubmit();
    } else {
      var btn = f.form.querySelector('[type="submit"]');
      if (btn) btn.click();
    }
    /* if the code is refused the form shows its own message and nothing re-renders: give the line back */
    setTimeout(function () { promo.classList.remove('lior-cart-promo--busy'); }, 6000);
  }

  document.addEventListener('click', function (e) {
    var promo = e.target && e.target.closest ? e.target.closest('cart-drawer .lior-cart-promo') : null;
    if (promo) apply(promo);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var promo = e.target && e.target.closest ? e.target.closest('cart-drawer .lior-cart-promo[role="button"]') : null;
    if (!promo) return;
    e.preventDefault();
    apply(promo);
  });

  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; sync(); });
  }
  function start() {
    sync();
    var d = drawer();
    if (d && window.MutationObserver) {
      new MutationObserver(queueSync).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-applied-codes'] });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Adorned by Lior - cart drawer shipping row (2026-10-15, owner: "like the Feetz cart", "real shipping price for each country").
   blocks/cart_subtotals.liquid prints the real one-piece price for every market currency. Only for a currency it does not know
   (data-lior-ship-live = the shopper's country) this asks Shopify's own shipping calculator for that country; if Shopify wants a
   full address it falls back to the flat rate converted at the store's exchange rate, rounded up to a whole unit as checkout does. */
(function () {
  if (window.__liorCartShip) return;
  window.__liorCartShip = true;
  var cache = {};
  function show(el, text, value) {
    /* 2026-10-23: format with the shop's own money format (thousands separators, decimals, prefix such as A$ / NT$). */
    var fmt = el.getAttribute('data-lior-fmt');
    if (fmt && typeof window.formatMoney === 'function') {
      try {
        var tmp = document.createElement('div');
        tmp.innerHTML = window.formatMoney(Math.round(value * 100), fmt);
        var t = (tmp.textContent || '').replace(el.getAttribute('data-lior-ms') || '$', el.getAttribute('data-lior-mp') || '$').trim();
        t = t.replace(/[.,]00(?=\D*$)/, ''); /* 2026-11-04 owner: no .00 on whole amounts */
        if (t) { el.textContent = t; el.style.visibility = ''; return; }
      } catch (e) {}
    }
    var m = text.match(/\d[\d.,\s]*\d|\d/);
    if (!m) return;
    var num = m[0];
    var dec = /,\d{2}$/.test(num) ? ',' : (/\.\d{2}$/.test(num) ? '.' : '');
    var whole = Math.abs(value - Math.round(value)) < 0.005; /* 2026-11-04 owner: cents only when there are cents */
    if (!whole && !dec) dec = '.';
    var out = whole ? String(Math.round(value)) : value.toFixed(2);
    if (dec === ',') out = out.replace('.', ',');
    el.textContent = text.replace(num, out);
    el.style.visibility = '';
  }
  function fallback(el, text) {
    var cur = window.Shopify && Shopify.currency ? Shopify.currency : null;
    var rate = cur ? parseFloat(cur.rate) : 0;
    var usd = parseFloat(el.getAttribute('data-lior-ship-usd'));
    if (rate && usd && cur.active !== 'USD') show(el, text, Math.ceil(usd * rate));
    else { el.textContent = 'Calculated at checkout'; el.style.visibility = ''; }
  }
  function run() {
    var els = document.querySelectorAll('[data-lior-ship-live]:not([data-lior-ship-done])');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-lior-ship-done', '1');
      var text = el.textContent;
      var country = el.getAttribute('data-lior-ship-live');
      var key = country + '|' + ((window.Shopify && Shopify.currency && Shopify.currency.active) || '');
      if (cache[key] != null) { show(el, text, cache[key]); return; }
      fetch('/cart/shipping_rates.json?shipping_address%5Bcountry%5D=' + encodeURIComponent(country), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var rate = j && j.shipping_rates && j.shipping_rates[0];
          if (rate) { cache[key] = parseFloat(rate.price); show(el, text, cache[key]); } else { fallback(el, text); }
        })
        .catch(function () { fallback(el, text); });
    });
  }
  function start() {
    run();
    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        (window.requestAnimationFrame || setTimeout)(function () { queued = false; run(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
